<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div
        v-if="role != 'pasien'"
        class="bg-light border-right"
        id="sidebar-wrapper"
      >
        <Sidebar active="Rekam Medis" :toReset="(url) => this.reset(url)" />
      </div>
      <div
        :id="
          role != ('pasien' || 'antrian')
            ? 'page-content-wrapper'
            : 'page-content-no-sidebar'
        "
      >
        <div class="container-fluid" v-if="loaded">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form id="formPasien"> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">data pasien</h5>
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">
                data penanggung jawab
              </h5>
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="text-uppercase text-info mb-3">data pembayaran</h5>
              <FormRow
                v-for="row in rightFormBottom"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div
            :class="`card p-3 float-bottom ${role == 'pasien' ? 'w-95' : ''}`"
          >
            <div class="row">
              <div class="col-md-12">
                <button
                  type="submit"
                  @click="handleForm"
                  class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                >
                  <i class="material-symbols-outlined">check</i>
                  Buat Data Pasien
                </button>
                <button
                  class="btn btn-outline-danger btn-no-outline float-right"
                  @click="() => reset('/pasien')"
                >
                  Batalkan
                </button>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
        <div class="container-fluid" v-else>
          <Loading />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import Loading from "@/components/Loading.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
import { leftForm, rightForm, rightFormBottom } from "@/data/PasienForm.js";
// import {resetForms,formatNumber,incrementNumber} from '@/data/helper.js';
import { resetForms, formatNumber, incrementNumber } from "@/data/helper.js";
import { regexErrors, regexes, regexPlaceholders } from "@/data/helper.js";
let data = {
  title: "Pasien Baru",
  backBtn: "/pasien",
  toReset: "",
  actionBtn: [],
  breadcrumb: [
    { title: "Pasien", link: "/pasien" },
    { title: "Baru", active: true },
  ],
};
function initialState() {
  return {
    fromUrl: "",
    plainUrl: "",
    loaded: false,
    validated: false,
    role: "",
    data: data,
    leftForm: leftForm,
    rightForm: rightForm,
    rightFormBottom: rightFormBottom,
    formSet: {
      asal_faskes: "",
      no_rm: "",
      id_provinsi: "",
      id_kota: "",
      id_kecamatan: "",
      id_kelurahan: "",
      id_provinsi_pj: "",
      id_kota_pj: "",
      id_kecamatan_pj: "",
      id_kelurahan_pj: "",
      id_asuransi: 1,
      nama: "",
      jen_kelamin: "",
      gol_darah: "",
      tmp_lahir: "",
      tgl_lahir: "",
      pendidikan: "",
      nama_ibu: "",
      agama: "",
      status_nikah: "",
      no_telp: "",
      pekerjaan: "",
      jenis_id: "KTP",
      no_id: "",
      alamat: "",
      pj_jenis: "",
      pj_nama: "",
      pj_pekerjaan: "",
      pj_alamat: "",
      asuransi_lain: "",
      no_peserta: "",
      foto: null,
      suku: "",
      email: "",
    },
  };
}
export default {
  name: "PasienForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    Loading,
    FormRow,
    // FormGroup
  },
  data: () => {
    return initialState();
  },
  methods: {
    handleForm: async function() {
      ////console.log(this.formSet.no_rm);
      this.loaded = false;
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, self.formSet[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post("pasien", formData);

          if (result.status == 200) {
            this.$store.state.HTTP_SIAKUN.post("kontak/tambah-simrs", {
              nama: this.formSet.nama,
              nomorTelepon: this.formSet.no_telp,
              kodeKontak: this.formSet.no_rm,
              isPelanggan: "1",
              isPemasok: "0",
              isKaryawan: "0",
            });
            this.validated = false;
            this.reset(`/ralan/form/${this.formSet.no_rm}`);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
        }
      } else {
        ////console.log("tidak valid");
      }
      this.loaded = true;
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.leftForm, this.rightForm, this.rightFormBottom],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    async handleChange(e, create) {
      ////console.log(create);
      ////console.log(e);
      ////console.log('masuk sini');
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }

      if (e.target.name == "id_provinsi" || e.target.name == "id_provinsi_pj") {
        ////console.log('masuk ke if');
        let cities =
          e.target.name == "id_provinsi"
            ? this.leftForm[9].columns[1]
            : this.rightForm[4].columns[1];
        await this.fetchCities(e.target.value, cities);
      } else if (e.target.name == "id_kota" || e.target.name == "id_kota_pj") {
        ////console.log('masuk else if euy');
        ////console.log(e.target.name);
        let districts =
          e.target.name == "id_kota"
            ? this.leftForm[10].columns[0]
            : this.rightForm[5].columns[0];
        ////console.log(e.target.value);
        await this.fetchDistricts(e.target.value, districts);
      } else if (
        e.target.name == "id_kecamatan" ||
        e.target.name == "id_kecamatan_pj"
      ) {
        let subdistricts =
          e.target.name == "id_kecamatan"
            ? this.leftForm[10].columns[1]
            : this.rightForm[5].columns[1];
        await this.fetchSubdistricts(e.target.value, subdistricts);
      } else if (e.target.name == "id_asuransi") {
        // Jika yang dipilih adalah Metode Pembayaran Umum

        if (e.target.value == 1) {
          // Hide kolom Pilih Asuransi
          this.rightFormBottom[1].columns[0].type = "hidden";
          // Hide Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].type = "hidden";
          // Reset Regex pada Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].value = "";
          this.rightFormBottom[2].columns[0].regex = "";
          this.rightFormBottom[2].columns[0].placeholder = "";
          this.rightFormBottom[2].columns[0].regexError = "";
          // Hide Kolom Asal Faskes
          this.rightFormBottom[3].columns[0].type = "hidden";
          // Reset nilai kolom Pilih Asuransi
          this.formSet["asuransi_lain"] = "";
          // Reset nilai kolom Nomor Peserta
          this.formSet["no_peserta"] = "";
          // Reset nilai kolom Asal Faskes
          this.formSet["asal_faskes"] = "";
        }
        // Jika yang dipilih adalah Metode Pembayaran BPJS
        else if (e.target.value == 2) {
          // Hide kolom Pilih Asuransi
          this.rightFormBottom[1].columns[0].type = "hidden";
          // Show kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].type = "text";
          this.rightFormBottom[2].columns[0].mandatory = true;
          this.rightFormBottom[2].columns[0].optional = false;
          // Set Regex pada Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].value = "";
          this.rightFormBottom[2].columns[0].regex = regexes.BPJS;
          this.rightFormBottom[2].columns[0].placeholder =
            regexPlaceholders.BPJS;
          this.rightFormBottom[2].columns[0].regexError = regexErrors.BPJS;
          // Show Kolom Asal Faskes
          this.rightFormBottom[3].columns[0].type = "select";
          // Reset nilai kolom Pilih Asuransi
          this.formSet["asuransi_lain"] = "";
          // Reset nilai kolom Nomor Peserta
          this.formSet["no_peserta"] = "";
        }
        // Jika yang dipilih adalah Metode Pembayaran Asuransi Lain
        else if (e.target.value == 3) {
          // Show kolom Pilih Asuransi
          this.rightFormBottom[1].columns[0].type = "select";
          // Show kolom nomor peserta
          this.rightFormBottom[2].columns[0].type = "text";
          this.rightFormBottom[2].columns[0].mandatory = false;
          this.rightFormBottom[2].columns[0].optional = true;
          // Reset Regex pada Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].value = "";
          this.rightFormBottom[2].columns[0].regex = "";
          this.rightFormBottom[2].columns[0].placeholder = "";
          this.rightFormBottom[2].columns[0].regexError = "";
          // Hide kolom asal faskes
          this.rightFormBottom[3].columns[0].type = "hidden";
          // Reset nilai Kolom asal faskes
          this.formSet["asal_faskes"] = "";
          // Reset nilai kolom Nomor Peserta
          this.formSet["no_peserta"] = "";
        }
        if (this.validated) {
          this.validateForm();
        }
      } else if (e.target.name == "jenis_id") {
        // Set Regex pada Kolom Nomor Identitas
        this.leftForm[7].columns[1].value = "";
        this.leftForm[7].columns[1].label = "Nomor " + e.target.value;
        this.leftForm[7].columns[1].regex = regexes[e.target.value];
        this.leftForm[7].columns[1].placeholder =
          regexPlaceholders[e.target.value];
        this.leftForm[7].columns[1].regexError = regexErrors[e.target.value];
        // Reset nilai kolom Nomor Identitas
        this.formSet["no_id"] = "";
        if (this.validated) {
          this.validateForm();
        }
      }
    },
    fetchProvinces: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "wilayah/provinsi?per_page=9999999999"
        );
        if (result.status == "200") {
          ////console.log(result);
          let provinces = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[9].columns[0].options = provinces;
          this.rightForm[4].columns[0].options = provinces;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchCities: async function(id, city) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kota?id_provinsi=${id}&per_page=9999999999`
        );
        if (result.status == "200") {
          ////console.log(result);
          city.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchFaskes: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "faskes?per_page=9999999999"
        );
        if (result.status == "200") {
          ////console.log(result);
          let faskes = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.rightFormBottom[3].columns[0].options = faskes;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchDistricts: async function(id, district) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kecamatan?id_kota=${id}&per_page=9999999999`
        );
        if (result.status == "200") {
          ////console.log(result);
          district.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchSubdistricts: async function(id, subdistrict) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kelurahan?id_kecamatan=${id}&per_page=9999999999`
        );
        if (result.status == "200") {
          ////console.log(result);
          subdistrict.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchAsuransi: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "asuransi_lain?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let items = result.data.data;
          ////console.log(items);
          this.rightFormBottom[1].columns[0].options = items.map(function(
            item
          ) {
            item.label = `${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            //console.log(column);
            if (column.regex) {
              //console.log(column.regex);
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      this.rightForm = this.rightForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            //console.log(column);
            if (column.regex) {
              //console.log(column.regex);
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      this.rightFormBottom = this.rightFormBottom.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            //console.log(column);
            if (column.regex) {
              //console.log(column.regex);
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }
          if (column.name == "foto") {
            if (self.formSet[column.name]) {
              var reader = new FileReader();
              reader.onload = function(e) {
                column.value = e.target.result;
                self.rightFormBottom.map((item) => {
                  item.columns = item.columns.map((column) => {
                    column.key = Math.random();
                    return column;
                  });
                  return item;
                });
              };
              reader.readAsDataURL(self.formSet[column.name]);
            }
          } else {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      this.validated = true;
      this.leftForm.splice(1, 1, this.leftForm[1]);
      this.rightForm.splice(1, 1, this.rightForm[1]);
      this.rightFormBottom.splice(1, 1, this.rightFormBottom[1]);
      setTimeout(function() {
        // ////console.log('berhasil masuk ke awal sini');
        self.rightFormBottom.map((item) => {
          item.columns = item.columns.map((column) => {
            column.key = Math.random();
            return column;
          });
          return item;
        });
        // ////console.log('berhasil masuk ke akhir sini');
      }, 2000);
      return valid;
    },
    generateNoRm: async function() {
      try {
        let result = await this.$store.state.HTTP.get(`pasien/generate/no_rm`);
        if (result.status == "200") {
          ////console.log(result);
          if (result.data.baru == result.data.terakhir) {
            this.formSet.no_rm = formatNumber(
              incrementNumber(result.data.terakhir),
              9
            );
          } else {
            this.formSet.no_rm = result.data.baru;
          }
          ////console.log(parseInt(this.formSet.no_rm)+1);
          ////console.log(this.formSet.no_rm);
          this.leftForm[0].columns[0].value = this.formSet.no_rm;
          ////console.log(this.leftForm[0].columns[0].value);
          this.leftForm.splice(0, 1, this.leftForm[0]);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.loaded = true;
    this.role = this.$store.state.role;
    this.data.toReset = (url) => this.reset(url);
    this.rightFormBottom[3].columns[0].refresh = this.fetchFaskes;
    this.rightFormBottom.splice(3, 1, this.rightFormBottom[3]);
    await this.generateNoRm();
    await this.fetchProvinces();
    await this.fetchFaskes();
    await this.fetchAsuransi();
    // resetForms();
  },
};
</script>
